/** Extract a human-readable message from an unknown caught value. */
export function errorMessage(error: unknown, fallback = 'Unknown error'): string {
  if (error instanceof Error) return error.message || fallback
  if (typeof error === 'string' && error) return error
  return fallback
}

/** Extract HTTP status from a FetchError-shaped value, or undefined. */
export function errorStatus(error: unknown): number | undefined {
  if (error instanceof Error && 'status' in error) {
    return (error as Error & { status?: number }).status
  }
  return undefined
}
